import { useEffect, useMemo, useState } from 'react';

interface IParams {
  textRef: React.RefObject<HTMLDivElement | null>;
  lineCount: number;
  lineHeight: number;
  expanded: boolean;
}

export const useExpandableState = ({ textRef, lineCount, lineHeight, expanded }: IParams) => {
  const [expandable, setExpandable] = useState(false);

  useEffect(() => {
    const textEl = textRef.current;

    /* istanbul ignore if */
    if (!textEl) {
      return;
    }

    const collapsedHeight = textEl.offsetHeight;
    const fullHeigh = textEl.scrollHeight;

    setExpandable(fullHeigh > collapsedHeight);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const collapsedHeight = useMemo(() => {
    return lineCount * lineHeight;
  }, [lineCount, lineHeight]);

  const maxHeight = useMemo(() => {
    return expanded ? 'none' : collapsedHeight;
  }, [expanded, collapsedHeight]);

  return {
    expandable,
    maxHeight,
  };
};
